import colors from "./colors";

const components = {
  MuiCssBaseline: {
    styleOverrides: `
      ::-webkit-scrollbar {
        width: 8px;
      }
      ::-webkit-scrollbar-track {
        background: ${colors.background.default};
        border-radius: 4px;
      }
      ::-webkit-scrollbar-thumb {
        background: ${colors.border.default};
        border-radius: 4px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${colors.gray[500]};
      }
      input[type="date"],
      input[type="datetime-local"],
      input[type="time"] {
        color-scheme: dark;
      }
      input[type="date"]::-webkit-calendar-picker-indicator,
      input[type="datetime-local"]::-webkit-calendar-picker-indicator,
      input[type="time"]::-webkit-calendar-picker-indicator {
        filter: brightness(0) invert(1);
        opacity: 0.85;
        cursor: pointer;
      }
    `,
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: colors.input.background,
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.input.border,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.input.borderFocus,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.input.borderFocus,
        },
        "&.Mui-error .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.input.borderError,
        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.input.borderDisabled,
        },
      },
      input: {
        color: colors.input.text,
        "&::placeholder": {
          color: colors.input.placeholder,
          opacity: 1,
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: colors.text.secondary,
        "&.Mui-focused": {
          color: colors.primary.main,
        },
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: colors.border.divider,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        backgroundColor: colors.background.paper,
        borderColor: colors.border.default,
      },
    },
  },
};

export default components;
